function base64UrlToUint8Array(value: string) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = `${value}${padding}`.replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let index = 0; index < raw.length; index += 1) {
    output[index] = raw.charCodeAt(index);
  }
  return output;
}

export async function getPushSupport() {
  const secureContext = window.isSecureContext !== false;
  const serviceWorker = "serviceWorker" in navigator;
  const pushManager = "PushManager" in window;
  const notifications = "Notification" in window;
  const available = secureContext && serviceWorker && pushManager && notifications;
  let reason: string | undefined;
  if (!secureContext) reason = "Phone notifications require HTTPS.";
  else if (!serviceWorker) reason = "This browser does not support service workers.";
  else if (!pushManager) reason = "This browser does not support Web Push.";
  else if (!notifications) reason = "This browser does not expose notification permissions.";
  else if (Notification.permission === "denied") reason = "Notifications are blocked for this site.";
  return {
    available,
    permission: notifications ? Notification.permission : "unsupported",
    reason
  };
}

async function serviceWorkerRegistration() {
  if (!("serviceWorker" in navigator)) {
    throw new Error("This browser does not support service workers.");
  }
  const existing = await navigator.serviceWorker.getRegistration("/");
  if (existing) return existing;
  return navigator.serviceWorker.register("/sw.js");
}

export async function currentPushSubscription() {
  const registration = await serviceWorkerRegistration();
  return registration.pushManager.getSubscription();
}

export async function subscribeToPush(publicKey: string) {
  const support = await getPushSupport();
  if (!support.available) {
    throw new Error(support.reason || "Phone notifications are not available.");
  }
  if (Notification.permission !== "granted") {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      throw new Error("Notification permission was not granted.");
    }
  }
  const registration = await serviceWorkerRegistration();
  return registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: base64UrlToUint8Array(publicKey)
  });
}

export async function unsubscribeFromPush() {
  const subscription = await currentPushSubscription();
  if (!subscription) return { endpoint: null, unsubscribed: false };
  const endpoint = subscription.endpoint;
  const unsubscribed = await subscription.unsubscribe();
  return { endpoint, unsubscribed };
}

